import { readSettingDetail } from '@/api/point/read';
import { updatePointSetting } from '@/api/point/update';
import Loading from '@/component/mui/Backdrop';
import PointSettingForm from '@/component/point/point-setting/Form';
import { compareObjects } from '@/lib/Compare';
import { AddCreatePointSettingType } from '@/types';
import { Box, Button } from '@mui/material';
import { MouseEvent, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function PointSettingDetail() {
  const {
    state: { settingId },
  } = useLocation();

  const [settings, setSettings] = useState<AddCreatePointSettingType | null>(null);
  const [oldSettings, setOldSettings] = useState(settings);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      const re = await readSettingDetail(settingId);
      console.log(re);
      setSettings(re.data);
      setOldSettings(re.data);
    })();
    return () => {};
  }, []);

  const onSubmit = async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsLoading(true);
    // 풀이름 추가, 설명 추가, 최소스테이킹 금액(달러), 이자율, 모금 기간, 운영기간, 최소최대 함수 호출
    console.log(settings);
    if (!settings || !oldSettings) {
      return;
    }
    console.log(typeof settings.referralReceivedMax);
    const data = compareObjects(settings, oldSettings);
    console.log(data);
    const result: any = {
      settingId: settings.settingId!,
      ...data,
    };
    console.log(typeof result.referralReceivedMax);
    try {
      const re = await updatePointSetting(result);
      if (re.status !== 200) {
        toast.error(re.message);
      }
      setIsLoading(false);
      toast.success(re.message);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
          padding: 2,
        }}
      >
        {settings && <PointSettingForm settings={settings} setSettings={setSettings} />}
        <Button variant="contained" onClick={onSubmit}>
          Update
        </Button>
      </Box>
      <Loading isLoading={isLoading} />
    </>
  );
}
